import React, { useCallback, useState } from "react"
import Select from "react-select"
import axios, { AxiosResponse } from "axios"
import useSelectReact from "@common-hooks/useSelectReact"

type Props = {
     url: string
     name: string
     value: string | number | Array<string | number> | undefined | null
     onChange: (value: any, opt: any) => void
     isInvalid: boolean
     isClearable?: boolean
     placeholder?: string
     method?: "POST" | "GET" /* TODO: get rid of method after adding common submodule to Talent. Only GET Requests will be sent. */
     payload?: {}
     isMulti?: boolean
     isSearchable?: boolean
     defaultOptions?: Array<{ label: string; value: string | number }>
     className?: string
     onFetch?: (totalOptions: number) => void
     disabled?: boolean
}

const MySelectGetAllDataFromServer: React.FC<Props> = ({
     name,
     value,
     onChange,
     onFetch = () => {},
     url,
     isClearable = true,
     isSearchable = true,
     placeholder = "Choisissez",
     method = "GET",
     payload = undefined,
     isMulti = false,
     defaultOptions = [],
     className = "",
     isInvalid,
     disabled = false,
}) => {
     const { formatGroupLabel, styles } = useSelectReact()

     const [isLoading, setIsLoading] = useState<boolean>(false)
     const [options, setOptions] = useState<any>(defaultOptions)
     const [noOptionsMessage, setNoOptionsMessage] = useState<string>("Aucun résultat")

     function getOptions() {
          setIsLoading(true)

          let result: any
          if (method === "GET") {
               /* Convert true to 1 and false to 0 for simplifying backend operations. */
               for (const key in payload) {
                    if (payload[key] === true) payload[key] = 1
                    if (payload[key] === false) payload[key] = 0
               }
               result = axios.get<Array<{ label: string; value: string | number }>>(url, { params: payload })
          } else {
               result = axios.post<Array<{ label: string; value: string | number }>>(url, payload)
          }

          result
               .then((r: AxiosResponse) => {
                    setOptions(r.data)
                    onFetch(r.data.length)
               })
               .catch(() => {
                    setOptions([])
                    setNoOptionsMessage("Une erreur est survenue")
               })
               .finally(() => {
                    setIsLoading(false)
               })
     }

     // selectValue is based on "value". It will get all options matching with value
     const selectValue = useCallback(() => {
          if (!value) return []
          if (Array.isArray(value)) {
               if (value.length == 0) return []

               let selectedOptions: any[] = []
               options.map((opt: any) => {
                    // if opt has options it means that it's an optgroup
                    if ("options" in opt) {
                         opt.options.map((item: any) => {
                              // @ts-ignore
                              if (value.includes(item.value)) selectedOptions.push(item)
                         })
                    } else {
                         if (value.includes(opt.value)) selectedOptions.push(opt)
                    }
               })
               return selectedOptions
          } else {
               return options.find((opt: any) => opt.value === value)
          }
     }, [value])

     return (
          <Select
               isDisabled={disabled}
               isClearable={isClearable}
               isSearchable={isSearchable}
               placeholder={placeholder}
               onFocus={getOptions}
               name={name}
               options={options}
               isLoading={isLoading}
               formatGroupLabel={formatGroupLabel}
               styles={styles(isInvalid)}
               isMulti={isMulti}
               loadingMessage={() => "Chargement en cours ..."}
               value={selectValue()}
               menuPortalTarget={document.body}
               onChange={val => {
                    if (Array.isArray(val)) {
                         onChange(
                              val.map(i => i.value),
                              val.map(i => i)
                         )
                    } else {
                         onChange(val?.value, val)
                    }
               }}
               noOptionsMessage={() => (options.length > 0 ? "Aucun résultat" : noOptionsMessage)}
               className={className}
          />
     )
}

export default MySelectGetAllDataFromServer
